// Toh DS no tema: comportamentos pequenos dos componentes.
// Chips roláveis (desenho 02.2): as setas aparecem só do lado que continua, e o chip escolhido vai para a vista.
(() => {
  function rolagem(caixa) {
    const trilho = caixa.querySelector('.collection-tabs__list');
    if (!trilho || caixa.dataset.rolagemPronta) return;
    caixa.dataset.rolagemPronta = 'true';
    const atualizar = () => {
      const fim = trilho.scrollWidth - trilho.clientWidth;
      caixa.classList.toggle('tem-esquerda', trilho.scrollLeft > 2);
      caixa.classList.toggle('tem-direita', trilho.scrollLeft < fim - 2);
    };
    caixa.querySelectorAll('[data-rolagem-seta]').forEach((seta) => {
      seta.addEventListener('click', () => {
        trilho.scrollBy({ left: Number(seta.dataset.rolagemSeta) * trilho.clientWidth * 0.7, behavior: 'smooth' });
      });
    });
    trilho.addEventListener('scroll', atualizar, { passive: true });
    trilho.addEventListener('click', (evento) => {
      const chip = evento.target.closest('.collection-tabs__list-link');
      if (chip) chip.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    });
    new ResizeObserver(atualizar).observe(trilho);
    atualizar();
  }
  const iniciar = () => document.querySelectorAll('[data-rolagem]').forEach(rolagem);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
  document.addEventListener('shopify:section:load', iniciar);
})();

// Calculadora de frete do produto (desenho 02.4): uma só, por delegação, porque a "Olhada rápida" injeta o HTML sem rodar scripts.
// A consulta passa pela fila da Shopify (prepare + async): a rota direta, /cart/shipping_rates.json, devolve 500 sem corpo
// quando a transportadora demora mais de 10 s, e a pessoa ficava sem resposta.
(() => {
  const LIMITE_COTACAO = 30000;
  const AVISO_DEMORA = 6000;
  const JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };
  const real = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
  const espera = (ms) => new Promise((pronto) => setTimeout(pronto, ms));
  const criar = (tag, classe, texto) => {
    const el = document.createElement(tag);
    if (classe) el.className = classe;
    if (texto) el.textContent = texto;
    return el;
  };

  const prazo = (dias) => {
    const d = (dias || []).filter((dia) => dia != null);
    if (!d.length) return '';
    if (d.length === 2 && d[0] !== d[1]) return `De ${d[0]} a ${d[1]} dias úteis`;
    return `Em ${d[0]} ${Number(d[0]) === 1 ? 'dia útil' : 'dias úteis'}`;
  };

  const mostrarCarregando = (caixa, cep) => {
    const linha = criar('p', 'response__carregando');
    linha.innerHTML = '<svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="spinner-path" fill="none" stroke-width="6" cx="33" cy="33" r="30" stroke="currentColor"></circle></svg>';
    const texto = criar('span', '', `Calculando o frete para ${cep}…`);
    linha.append(texto);
    caixa.replaceChildren(linha);
    return setTimeout(() => { texto.textContent = 'Ainda consultando as transportadoras. Só mais alguns segundos…'; }, AVISO_DEMORA);
  };

  const mostrarAviso = (caixa, mensagem, tentarDeNovo) => {
    const aviso = criar('p', 'response__aviso', mensagem);
    if (tentarDeNovo) {
      const botao = criar('button', 'response__tentar', 'Tentar de novo');
      botao.type = 'button';
      botao.addEventListener('click', tentarDeNovo);
      aviso.append(' ', botao);
    }
    caixa.replaceChildren(aviso);
  };

  // A opção mais barata vem primeiro. Frete grátis aparece como "Grátis", nunca como R$ 0,00.
  const mostrarOpcoes = (caixa, cep, local, opcoes) => {
    const titulo = criar('p', 'response__titulo');
    titulo.append('Entrega no CEP ', criar('b', '', cep), ` · ${local}`);
    const lista = criar('ul', 'response__rates');
    [...opcoes].sort((a, b) => Number(a.price) - Number(b.price)).forEach((opcao) => {
      const gratis = !(Number(opcao.price) > 0);
      const nome = criar('span', 'response__nome');
      nome.append(criar('b', '', opcao.name));
      const dias = prazo(opcao.delivery_days);
      if (dias) nome.append(criar('span', 'response__prazo', dias));
      const preco = criar('b', `response__preco${gratis ? ' response__preco--gratis' : ''}`, gratis ? 'Grátis' : real.format(Number(opcao.price)));
      const item = criar('li');
      item.append(nome, preco);
      lista.append(item);
    });
    caixa.replaceChildren(titulo, lista);
  };

  const cotar = async (consulta) => {
    const preparo = await fetch(`/cart/prepare_shipping_rates.json?${consulta}`, { method: 'POST', headers: { Accept: 'application/json' } });
    if (!preparo.ok) throw new Error(`prepare ${preparo.status}`);
    const limite = Date.now() + LIMITE_COTACAO;
    while (Date.now() < limite) {
      const resposta = await fetch(`/cart/async_shipping_rates.json?${consulta}`, { headers: { Accept: 'application/json' } });
      if (resposta.status === 200) {
        const dados = await resposta.json();
        if (dados && dados.shipping_rates) return dados.shipping_rates;
      } else if (resposta.status !== 202) {
        throw new Error(`async ${resposta.status}`);
      }
      await espera(1000);
    }
    throw new Error('tempo esgotado');
  };

  // Tira a unidade que entrou só para a cotação. Se a pessoa comprou o mesmo produto nesse meio-tempo, a compra dela fica.
  const retirarDoCarrinho = async (chave) => {
    const { items } = await (await fetch('/cart.js')).json();
    const linha = items.find((item) => item.key === chave);
    if (linha) await fetch('/cart/change.js', { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ id: chave, quantity: linha.quantity - 1 }) });
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  };

  const calcular = async (calculadora) => {
    if (calculadora.dataset.calculando) return;
    const campo = calculadora.querySelector('.js-zip');
    const botao = calculadora.querySelector('.js-button');
    const caixa = calculadora.querySelector('.shipping__response');
    const digitos = campo.value.replace(/\D/g, '');
    if (digitos.length !== 8) {
      mostrarAviso(caixa, 'Digite um CEP com 8 números.');
      campo.focus();
      return;
    }
    const cep = `${digitos.slice(0, 5)}-${digitos.slice(5)}`;
    campo.value = cep;
    calculadora.dataset.calculando = 'true';
    botao.disabled = true;
    caixa.setAttribute('aria-busy', 'true');
    const demora = mostrarCarregando(caixa, cep);
    let temporario = null;
    try {
      const endereco = await (await fetch(`https://viacep.com.br/ws/${digitos}/json/`)).json();
      if (endereco.erro) {
        mostrarAviso(caixa, 'Não encontramos esse CEP. Confira os números.');
        return;
      }
      // A cotação sai do carrinho, e a frase do frete grátis conta o produto da tela: ele entra por um instante, para os dois baterem.
      // No carrinho não há régua nem produto da tela: a cotação sai do próprio carrinho.
      const variante = calculadora.querySelector('.free-shipping')?.dataset.variante;
      const carrinho = await (await fetch('/cart.js')).json();
      if (variante && !carrinho.items.some((item) => String(item.variant_id) === variante)) {
        const adicao = await fetch('/cart/add.js', { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ id: Number(variante), quantity: 1 }) });
        if (adicao.ok) temporario = (await adicao.json()).key;
        else if (!carrinho.item_count) {
          mostrarAviso(caixa, 'Esta opção está esgotada. Escolha outra para calcular o frete.');
          return;
        }
      }
      const consulta = new URLSearchParams({ 'shipping_address[zip]': cep, 'shipping_address[country]': 'Brazil', 'shipping_address[province]': endereco.estado });
      const opcoes = await cotar(consulta);
      calculadora.dataset.cotado = digitos;
      if (opcoes.length) mostrarOpcoes(caixa, cep, `${endereco.localidade}/${endereco.uf}`, opcoes);
      else mostrarAviso(caixa, 'Nós não entregamos para esse endereço.');
    } catch (erro) {
      console.error('Frete:', erro);
      mostrarAviso(caixa, 'Não conseguimos calcular o frete agora. O valor aparece na finalização da compra.', () => botao.click());
    } finally {
      if (temporario) await retirarDoCarrinho(temporario).catch((erro) => console.error('Frete:', erro));
      clearTimeout(demora);
      delete calculadora.dataset.calculando;
      botao.disabled = false;
      caixa.removeAttribute('aria-busy');
    }
  };

  document.addEventListener('click', (evento) => {
    const botao = evento.target.closest('.shipping-calculator .js-button');
    if (!botao) return;
    evento.preventDefault();
    calcular(botao.closest('.shipping-calculator'));
  });
  document.addEventListener('keypress', (evento) => {
    if (evento.key !== 'Enter' || !evento.target.matches('.shipping-calculator .js-zip')) return;
    evento.preventDefault();
    calcular(evento.target.closest('.shipping-calculator'));
  });

  // Carrinho (lateral ou página): com CEP salvo, as opções aparecem sozinhas e acompanham o que muda no carrinho.
  // O carrinho lateral só consulta aberto; ao redesenhar, a calculadora é nova e cota de novo.
  const cotarCarrinho = () => {
    const cep = localStorage.getItem('user_cep') || '';
    if (cep.length !== 8) return;
    document.querySelectorAll('.shipping-calculator--carrinho').forEach((calculadora) => {
      const gaveta = calculadora.closest('.cart-drawer');
      if ((gaveta && !gaveta.classList.contains('active')) || calculadora.dataset.cotado === cep) return;
      calculadora.querySelector('.js-zip').value = `${cep.slice(0, 5)}-${cep.slice(5)}`;
      calcular(calculadora);
    });
  };
  ['cart-drawer:open', 'cart-drawer:atualizada', 'line-item:change:end'].forEach((nome) => document.addEventListener(nome, cotarCarrinho));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', cotarCarrinho);
  else cotarCarrinho();
})();

// Tabela de medidas (snippet-tabela-medidas): botão e diálogo. Clique delegado, porque o botão também
// aparece na "Olhada rápida", que injeta o HTML sem rodar os scripts embutidos.
// Aberto, o diálogo vai para o fim do <body>, acima do cabeçalho; ao fechar, volta para o lado do botão.
(() => {
  let quemAbriu = null;
  const fechar = (modal) => {
    modal.hidden = true;
    if (quemAbriu && quemAbriu.isConnected) {
      quemAbriu.after(modal);
      quemAbriu.focus();
    } else {
      modal.remove();
    }
  };
  document.addEventListener('click', (evento) => {
    const abrir = evento.target.closest('[data-tabela-medidas-abrir]');
    if (abrir) {
      const modal = abrir.nextElementSibling;
      if (!modal || !modal.matches('[data-tabela-medidas]')) return;
      quemAbriu = abrir;
      document.body.appendChild(modal);
      modal.hidden = false;
      modal.querySelector('[data-tabela-medidas-fechar]').focus();
      return;
    }
    const modal = evento.target.closest('[data-tabela-medidas]');
    if (modal && (evento.target === modal || evento.target.closest('[data-tabela-medidas-fechar]'))) fechar(modal);
  });
  document.addEventListener('keydown', (evento) => {
    if (evento.key !== 'Escape') return;
    document.querySelectorAll('[data-tabela-medidas]:not([hidden])').forEach(fechar);
  });
})();

// Painéis laterais da busca e da "Olhada rápida": aberto, o Tab fica dentro do painel; ao fechar (Esc, X ou clique
// fora), o foco volta a quem o abriu, como no carrinho lateral (toh-carrinho.js). A "Olhada rápida" não recebe foco
// pelo teclado, então o foco volta ao nome do produto no card.
(() => {
  const FOCAVEIS = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  const visivel = (el) => el && el.isConnected && el.getClientRects().length > 0;
  const PAINEIS = [
    { id: 'Search-Drawer', gatilho: '.thb-quick-search', volta: (g) => g, reserva: () => [...document.querySelectorAll('.thb-quick-search')].find(visivel) },
    { id: 'Product-Drawer', gatilho: 'quick-view', volta: (g) => { const card = g.closest('.product-card'); return (card && card.querySelector('a.product-card-title, a[href]')) || g; }, reserva: () => null },
  ];
  const gatilhos = {};
  document.addEventListener('click', (evento) => {
    PAINEIS.forEach((cfg) => { const botao = evento.target.closest(cfg.gatilho); if (botao) gatilhos[cfg.id] = botao; });
  }, true);
  const aberto = () => PAINEIS.map((cfg) => document.getElementById(cfg.id)).find((p) => p && p.classList.contains('active'));
  document.addEventListener('keydown', (evento) => {
    if (evento.key !== 'Tab') return;
    const p = aberto();
    if (!p) return;
    const lista = [...p.querySelectorAll(FOCAVEIS)].filter(visivel);
    if (!lista.length) return;
    const primeiro = lista[0];
    const ultimo = lista[lista.length - 1];
    if (!p.contains(document.activeElement)) {
      evento.preventDefault();
      primeiro.focus();
    } else if (evento.shiftKey && (document.activeElement === primeiro || document.activeElement === p)) {
      evento.preventDefault();
      ultimo.focus();
    } else if (!evento.shiftKey && document.activeElement === ultimo) {
      evento.preventDefault();
      primeiro.focus();
    }
  });
  const vigiar = () => PAINEIS.forEach((cfg) => {
    const p = document.getElementById(cfg.id);
    if (!p) return;
    new MutationObserver(() => {
      if (p.classList.contains('active')) return;
      if (!p.contains(document.activeElement) && document.activeElement !== document.body) return;
      const g = gatilhos[cfg.id];
      let alvo = g && g.isConnected ? cfg.volta(g) : null;
      if (!visivel(alvo)) alvo = cfg.reserva();
      if (alvo) alvo.focus();
    }).observe(p, { attributes: true, attributeFilter: ['class'] });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', vigiar);
  else vigiar();
})();

// Carrosséis (Flickity): o contorno de foco só pelo teclado. O Flickity foca o carrossel a cada toque ou clique, para
// as setas do teclado funcionarem, e o navegador desenhava esse foco como se viesse do teclado: uma linha preta no topo
// do carrossel depois de arrastar. A marca sai na primeira tecla, e aí o contorno volta.
(() => {
  document.addEventListener('pointerdown', (evento) => {
    const carrossel = evento.target.closest && evento.target.closest('.flickity-enabled');
    if (carrossel) carrossel.dataset.focoPonteiro = '';
  }, true);
  document.addEventListener('keydown', () => {
    document.querySelectorAll('[data-foco-ponteiro]').forEach((carrossel) => delete carrossel.dataset.focoPonteiro);
  }, true);
})();

// Swishlist: o aviso "Adicionado à lista de desejos" no canto direito de baixo. A posição vem da configuração do app,
// guardada por tema (estava no canto esquerdo de cima, sobre o menu). O app lê a posição a cada aviso e cuida do
// empilhamento e da animação; o tema só troca o valor antes do clique chegar ao app.
(() => {
  const posicionar = () => {
    const aviso = window.SWishlistConfiguration && window.SWishlistConfiguration.themeSettings && window.SWishlistConfiguration.themeSettings.notificationPopup;
    if (aviso) aviso.placement = 'right_bottom';
  };
  document.addEventListener('click', posicionar, true);
  window.addEventListener('load', posicionar);
})();

// Judge.me, formulário de avaliação: o seletor "exibido publicamente como" trazia o exemplo do app em inglês ("John
// Smith", "John S.", "J.S."). Antes de digitar, cada opção diz o formato; com o nome digitado, mostra como ele vai
// aparecer. Só o texto das opções muda: o valor enviado ao Judge.me é o mesmo.
(() => {
  const FORMATOS = { '': 'Nome completo', last_initial: 'Nome e inicial', first_name_only: 'Só o nome', all_initials: 'Iniciais' };
  const inicial = (parte) => parte.charAt(0).toLocaleUpperCase('pt-BR') + '.';
  const exibido = (formato, partes) => {
    const nome = partes[0];
    const sobrenome = partes.length > 1 ? partes[partes.length - 1] : '';
    if (formato === 'last_initial') return sobrenome ? `${nome} ${inicial(sobrenome)}` : nome;
    if (formato === 'first_name_only') return nome;
    if (formato === 'all_initials') return inicial(nome) + (sobrenome ? inicial(sobrenome) : '');
    return partes.join(' ');
  };
  const rotular = (seletor) => {
    const campo = seletor.closest('.jdgm-form__fieldset') && seletor.closest('.jdgm-form__fieldset').querySelector('input[name="reviewer_name"]');
    const partes = campo ? campo.value.trim().split(/\s+/).filter(Boolean) : [];
    seletor.setAttribute('aria-label', 'Exibido publicamente como');
    for (const opcao of seletor.options) {
      if (!(opcao.value in FORMATOS)) continue;
      const texto = partes.length ? exibido(opcao.value, partes) : FORMATOS[opcao.value];
      // Só troca o que mudou: cada troca é uma mudança no widget, e o vigia abaixo voltaria aqui sem parar.
      if (opcao.textContent !== texto) opcao.textContent = texto;
    }
  };
  const rotularTodos = (raiz) => raiz.querySelectorAll('select[name="reviewer_name_format"]').forEach(rotular);
  document.addEventListener('input', (evento) => {
    if (!evento.target.matches || !evento.target.matches('.jdgm-form input[name="reviewer_name"]')) return;
    const seletor = evento.target.closest('.jdgm-form__fieldset').querySelector('select[name="reviewer_name_format"]');
    if (seletor) rotular(seletor);
  });
  // O Judge.me monta o formulário depois de carregar: cada widget de avaliações é vigiado até o seletor aparecer.
  const vigiar = () => document.querySelectorAll('.jdgm-review-widget').forEach((widget) => {
    rotularTodos(widget);
    new MutationObserver(() => rotularTodos(widget)).observe(widget, { childList: true, subtree: true });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', vigiar);
  else vigiar();
})();
